export default "# Getting Started\n\n## Setup \n\nTODO\n"